var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9118 26.9999L19.0151 16.5286L15.6108 10.689L9.50753 21.1602L3.40423 10.689L0 16.5286L6.1033 26.9999H12.9118Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5097 11.6806L12.9139 5.83967L9.5097 0L6.10547 5.83967L9.5097 11.6806Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrey);
export default __webpack_public_path__ + "static/media/logo_grey.89dbec5c0bc245f9a85e880ad09c7452.svg";
export { ForwardRef as ReactComponent };